<template>
  <div class="popUp-content !m-0 !pb-2">
    <div class="text-left !pt-3 !mb-4">
      <el-radio-group v-model="field.is_global_variable">
        <el-radio-button :label="false">Custom Field</el-radio-button>
        <el-radio-button :label="true">Global Variable</el-radio-button>
      </el-radio-group>
    </div>
    <el-form label-position="right" v-if="!field.is_global_variable">
      <title-and-description :field="field" />
      <el-row type="flex" :gutter="20">
        <el-col :span="12">
          <placeholder :field="field" />
        </el-col>
        <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="20">
        <el-col :span="24" v-if="!field.is_fixed" class="flex items-center !gap-4">
          <el-radio-group
            v-if="!field.is_fixed"
            v-model="field.timeFormat"
            size="medium"
            class="!border !border-black/20 rounded-md"
          >
            <el-radio-button class="!border-r !border-black/20" label="12">12-Hour</el-radio-button>
            <el-radio-button label="24">24-Hour</el-radio-button>
          </el-radio-group>
          <el-button
            class="!border-0 !text-[#F2994A] underline !font-normal !px-0 !bg-transparent hover:!bg-transparent hover:text-[#f2994a]"
            v-if="!field.is_fixed"
            @click="field.timeFormat = null"
          >
            Reset to Default
          </el-button>
        </el-col>
        <el-col :span="24" v-if="field.is_fixed">
          <el-row type="flex" :gutter="20">
            <el-col :span="12">
              <div>
                <label
                  class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
                >
                  Time range
                </label>
                <el-time-picker
                  class="!w-full"
                  is-range
                  v-model="field.properties.time_range"
                  range-separator="To"
                  start-placeholder="Start time"
                  end-placeholder="End time"
                ></el-time-picker>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <label
                  class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
                >
                  Step
                </label>
                <el-select
                  placeholder="Step time"
                  v-model="field.properties.step_time"
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="t in 11"
                    :key="t + 'start'"
                    :value="t * 5 + ':00'"
                    :label="t * 5 + ' minutes'"
                  >
                    {{ t * 5 + ' minutes' }}
                  </el-option>
                  <el-option
                    v-for="t in 7"
                    :key="t + 'start_hours'"
                    :value="t * 60 + ':00'"
                    :label="t * 60 + ' minutes'"
                  >
                    {{ t * 60 + ' minutes' }}
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row type="flex" :gutter="20">
        <el-col :span="12">
          <is-field-required :field="field" />
        </el-col>
        <el-col :span="12">
          <div class="icon-dropdown-selection flex items-center !gap-3">
            <span
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
            >
              Icon
            </span>
            <el-button type="text" @click="iconPickerdialogVisible = true">
              <div class="d-flex align-center menu-icon !gap-2">
                <span>
                  <icons :iconName="templateIconPath"></icons>
                </span>
                <i class="el-icon-circle-plus !text-brand-500"></i>
              </div>
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-form label-position="right" v-if="field.is_global_variable">
      <el-row type="flex" :gutter="20">
        <el-col :span="12">
          <div class="form-group">
            <el-form-item>
              <label
                class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
              >
                Global Variable
              </label>
              <el-select
                class="w-full"
                v-model="field.global_variable_id"
                @change="setGlobalVariable"
              >
                <el-option
                  v-for="(globalVariable, index) of allGlobalVariables"
                  :key="index"
                  :label="globalVariable.label"
                  filterable
                  :value="globalVariable._id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <placeholder :field="field" />
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="20">
        <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
        <el-col :span="12">
          <is-field-required :field="field" class="field-required" />
        </el-col>
      </el-row>
    </el-form>
    <dialog-component
      :title="'Select An Icon'"
      :visible="iconPickerdialogVisible"
      :containerWidth="getIsMobile ? '100%' : '77%'"
      @before-close="closeSelectIcon"
      :isShowFooter="false"
      :selectedIcon="field.icon_name"
    >
      <div class="icons-component">
        <div class="iconslistScrollable">
          <icons-list @icon-data="getIconPath"></icons-list>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
  import { fetchGlobalVariables } from '@/repo/globalVariables';
  export default {
    components: {
      TitleAndDescription: () => import('./TitleAndDescription'),
      IsFieldRequired: () => import('./IsFieldRequired'),
      FieldFilledBy: () => import('./FieldFilledBy'),
      Placeholder: () => import('./Placeholder'),
    },
    props: ['field'],
    computed: {
      allGlobalVariables() {
        return this.getAllGlobalVariables ? this.getAllGlobalVariables.data || [] : [];
      },
    },
    data() {
      return {
        validations: [],
        iconPickerdialogVisible: false,
        getAllGlobalVariables: null,
        templateIconPath: 'dashboard',
      };
    },
    mounted() {
      this.fetchGlobalVaribales();
      if (this.field && this.field.icon_name) {
        this.templateIconPath = this.field.icon_name;
      }
      if (this.field && !this.field.properties) {
        this.$set(this.field, 'properties', {
          time_range: [new Date(2016, 9, 10, 0, 0), new Date(2016, 9, 10, 23, 59, 59)],
          step_time: '00:30',
        });
      }
    },
    methods: {
      closeSelectIcon() {
        this.iconPickerdialogVisible = false;
      },
      getIconPath(icon) {
        this.templateIconPath = icon;
        this.$set(this.field, 'icon_name', icon);
        this.iconPickerdialogVisible = false;
      },
      async fetchGlobalVaribales() {
        let params = {
          get_all: true,
          input_type: this.field.input_type,
        };
        if (this.field.is_fixed) {
          params['is_fixed'] = true;
        }
        this.getAllGlobalVariables = await fetchGlobalVariables(params);
      },
      setGlobalVariable() {
        let globalVariable = this.allGlobalVariables.find(
          (x) => x._id == this.field.global_variable_id
        );
        this.field.label = globalVariable.label;
        this.field.description = globalVariable.description;
      },
    },
  };
</script>

<style lang="scss"></style>
